/**
 * This Error exists so that we can specifically
 * capture and handle this particular error in the
 * ErrorBoundary
 */
export const markdownConversionErrorName = 'MarkdownConversionError';
export class MarkdownConversionError extends Error {
  constructor({
    message,
    type
  }) {
    super(message);
    this.name = markdownConversionErrorName;
    this.type = type;
  }
}